jQuery(function($){
    // MOBILE ONLY (below the header breakpoint — keep in sync with $header_bp)
    if(Modernizr.mq('only screen and (max-width: 859px)')) {
        $('.nav-wrap .main-nav > li').each(function(){
            if( $(this).find('> .sub-menu').length ) {
                var opener = $(this).find('> a').clone().empty().addClass('opener');
                $(this).append(opener);
                $(this).find('> a.opener').on('click',function(e){
                    e.preventDefault();
                    $(this).parent().siblings().removeClass('open');
                    $(this).parent().toggleClass('open');
                }).next('.sub-menu').prepend($('<li/>'));
            }

        });
    }

    // DESKTOP ONLY (at/above the header breakpoint — keep in sync with $header_bp)
    if(Modernizr.mq('only screen and (min-width: 860px)')) {
        // $(window).scroll(function(){
        //     if ($(window).scrollTop() >= 130) {
        //         $('body').addClass('sticky');
        //     } else {
        //         $('body').removeClass('sticky');
        //     }
        // });
    }

    // SEARCH
    $('.main-nav .search-toggle').on('click', function(e) {
        e.preventDefault();
        $('html').toggleClass('search-open');
        $(this).toggleClass('active');
    });

    // SAMPLE AJAX ON CLICK EXAMPLE
    $('.AJAX_FILTER').on('click','a',function(e){
        e.preventDefault();
        var theData = $(this).data('type');
    
        $(this).addClass('active').siblings().removeClass('active');

        results = $('.results-wrap .ajax-results');

        ajaxSimple('ajax_function_name',theData,results);
    });

    // CAROUSEL UNCOMMENT IF NEEDED 
    // var carousel_wrap = tns({
    //   container: '.carousel-wrap',
    //   items: 1,
    //   lazyLoad: true,
    //   autoplay: false,
    //   nav: true,
    //   loop: false,
    //   controls: false,
    //   mouseDrag: true
    // });

    // $('.main-nav li.popup a, .footer-text .popup').magnificPopup({
    //   type: 'inline',
    //   removalDelay: 300,
    //   mainClass: 'mfp-img-mobile',
    // });

    // $('.gallery-thumbnails').magnificPopup({
    //     delegate: 'a',
    //     type: 'image',
    //     closeOnContentClick: false,
    //     mainClass: 'mfp-with-zoom mfp-img-mobile',
    //     removalDelay: 300,
    //     image: {
    //         verticalFit: true
    //     },
    //     gallery: {
    //         enabled: true,
    //         navigateByImgClick: true,
    //         preload: [0,1]
    //     },
    // });

    // $('.some-link').on('click',function(e){
    //     e.preventDefault();
    //     $.magnificPopup.open({
    //         items: {
    //             src: '#some-popup'
    //         },
    //         type: 'inline',
    //         removalDelay: 300,
    //         mainClass: 'mfp-fade'
    //     });
    //     return false;
    // });
    
});

/* - - - - - - - - - - - - - - - - - - - - - - - - - -
   SCROLL REVEAL
   Toggles the `.on` class on elements as they scroll into view so the
   `.animate-*` styles in scss/partials/_js-loaded.scss play. Works with
   the manual .animate-up / -down / -left / -right classes AND auto-applies
   a gentle fade-up to key content sections site-wide.

   Opt an element (or a whole subtree) out with the `.no-animate` class.
   Requires html.js (set via Modernizr) — if JS is off, everything stays
   visible. Honors prefers-reduced-motion.
*/
(function () {
  // Elements to reveal. Manual classes first, then site-wide auto targets.
  var TARGETS = [
    ".animate-up",
    ".animate-down",
    ".animate-left",
    ".animate-right",
    ".ezmicro-hero .container > *", // hero heading / copy / cta
    ".black-bar h2", // sub-heading bar
    ".entry-content > *:not(.results-wrap)", // top-level page/post blocks
    ".loop-wrap", // blog / archive cards
  ].join(",");

  var STAGGER = 90; // ms between items that enter together (rows, grids)
  var MAX_STEPS = 6; // cap the cascade so big batches don't lag

  function ready(fn) {
    if (document.readyState !== "loading") {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }

  ready(function () {
    var candidates = Array.prototype.slice.call(
      document.querySelectorAll(TARGETS)
    );

    // Drop opt-outs, and any element nested inside another target so a
    // parent block animates as one unit instead of fighting its children.
    var els = candidates.filter(function (el) {
      if (el.closest(".no-animate")) return false;
      var parent = el.parentElement;
      while (parent) {
        if (candidates.indexOf(parent) !== -1) return false;
        parent = parent.parentElement;
      }
      return true;
    });

    if (!els.length) return;

    var reduce =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    // No motion wanted, or no observer support: just show everything.
    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach(function (el) {
        el.classList.add("on");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        // Reveal in visual order; stagger items appearing in the same batch.
        var showing = entries
          .filter(function (e) {
            return e.isIntersecting;
          })
          .sort(function (a, b) {
            var ra = a.boundingClientRect,
              rb = b.boundingClientRect;
            return ra.top - rb.top || ra.left - rb.left;
          });

        showing.forEach(function (entry, i) {
          var el = entry.target;
          var delay = Math.min(i, MAX_STEPS) * STAGGER;
          if (delay) el.style.transitionDelay = delay + "ms";
          el.classList.add("on");
          obs.unobserve(el);
        });
      },
      {
        // Fire just before the element is fully in view, near the bottom edge.
        rootMargin: "0px 0px -10% 0px",
        threshold: 0.05,
      }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  });
})();